<template>
    <ion-page>
        <ion-loading :is-open="busy" message="Loading, please wait"/>
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="end">
                    <ion-button @click="close()">
                        <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title>Process Return</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content>
            <product-card-modal ref="product" :item="item" />
            <ion-list v-if="removal && removal.id || newReturnItem">
                <ion-item v-if="removal && removal.id">
                    <ion-label>
                        <div v-if="removal.is_amazon">
                            <h2>Amazon Removal Order #</h2>
                            <p v-if="removal.source">{{ removal.source.removal_order_id.toUpperCase() }}
                                ({{ removal.source.quantity_shipped }} / {{ removal.source.quantity }} shipped by Amazon)
                            </p>
                        </div>
                        <div v-else>Customer Return</div>
                    </ion-label>
                </ion-item>
                <ion-item detail button @click="$refs['product'].open()">
                    {{ item.item_number }} Product Card
                </ion-item>
                <ion-item lines="none">
                    <big-stepper label="Qty Received" v-model="qty_received" />
                </ion-item>
                <ion-item lines="none">
                    <big-stepper label="Qty To Bin" v-model="qty_to_bin" />
                </ion-item>
                <ion-item lines="none">
                    <big-stepper label="Qty To Relabel" v-model="qty_to_relabel" />
                </ion-item>
                <ion-item v-if="!removal.is_amazon">
                    <ion-label>Reason</ion-label>
                    <stock-return-reason-select v-model="reason" />
                </ion-item>
            </ion-list>
        </ion-content>
        <ion-footer>
            <ion-button color="warning" class="ion-margin-top" size="large" expand="full" @click="save">
                RECEIVE
            </ion-button>
        </ion-footer>
    </ion-page>
</template>

<script>
import {
    IonPage,
    IonLoading,
    IonContent,
    IonLabel,
    IonItem,
    IonList,
    IonFooter,
    IonButton,
    IonIcon,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonTitle,
    modalController
} from "@ionic/vue";
import ProductCardModal from "@/components/Modals/ProductCardModal";
import BigStepper from "@/components/BigStepper";
import {closeOutline} from 'ionicons/icons';
import StockReturnReasonSelect from "@/components/StockReturnReasonSelect";
export default {
    name: "Assess",
    inject: ['$http', '$toast', '$validationAlert'],
    components: {
        StockReturnReasonSelect,
        BigStepper,
        ProductCardModal,
        IonPage,
        IonLoading,
        IonContent,
        IonLabel,
        IonList,
        IonItem,
        IonFooter,
        IonButton,
        IonIcon,
        IonHeader,
        IonToolbar,
        IonButtons,
        IonTitle
    },
    props: {
        itemReturn: Object,
        newReturn: Boolean,
        newReturnItem: Object
    },
    computed: {
        item() {
            if (this.newReturnItem) {
                return this.newReturnItem || {};
            }
            return this.removal.item;
        },
        title() {
            if (!this.removal.id) {
                return '';
            }

            if (!this.removal.is_amazon) {
                return 'Customer Return';
            }

            if (this.removal.source_name.toUpperCase() === 'AMAZONREMOVALORDER') {
                return 'FBA Removal Order';
            }
            return 'Return';
        }
    },
    mounted() {
        if (this.newReturnItem) {
            return;
        }

        this.busy = true;
        this.$http
            .get(`/api/returns/${this.itemReturn.id}`, {
                params: {include: 'item,source'}
            })
            .then(response => {
                this.removal = response.data;
                this.qty_received = response.data.qty_received;
                console.log(this.qty_received, response.data);
            }).catch(error => {
                this.$validationAlert(error);
            }).finally(() => {
                this.busy = false;
            });
    },
    methods: {
        close() {
            modalController.dismiss(this.itemReturn);
        },
        save() {
            this.busy = true;
            const payload = {
                qty_to_bin: this.qty_to_bin,
                qty_to_relabel: this.qty_to_relabel,
                qty_received: this.qty_received,
                reason: this.reason
            };

            let method = 'put';
            let url = '';
            if (this.newReturnItem) {
                url = '/api/returns';
                method = 'post';
                payload.item_id = this.newReturnItem.id;
            } else {
                url = `/api/returns/${this.itemReturn.id}`
            }

            this.$http({
                    url: url,
                    method: method,
                    data: payload
                }).then(() => {
                    this.busy = false;
                    setTimeout(() => {
                        this.close();
                    }, 500);
                    this.$toast.success("Return ready to stack");
                }).catch(error => {
                    this.busy = false;
                    this.$validationAlert(error);
                });
        }
    },
    data() {
        return {
            busy: false,
            removal: {},
            reason: '',
            qty_to_relabel: 0,
            qty_to_bin: 0,
            qty_received: 0
        }
    },
    setup() {
        return {closeOutline};
    }
}
</script>

<style scoped>

</style>
